/**
 * @file index.tsx
 *
 * @fileoverview Shows a placeholder when a blog teaser is loading.
 */

import ContentLoader from "react-content-loader";

export function BlogTeaserPlaceholder() {
  return (
    <ContentLoader
      width={370}
      height={680}
      speed={2}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      uniqueKey="blog-teaser"
    >
      <rect x="8" y="10" rx="0" ry="0" width="366" height="185" />
      <rect x="39" y="215" rx="0" ry="0" width="300" height="28" />
      <rect x="39" y="245" rx="0" ry="0" width="241" height="25" />
      <rect x="40" y="292" rx="0" ry="0" width="287" height="17" />
      <rect x="39" y="317" rx="0" ry="0" width="267" height="16" />
      <rect x="38" y="341" rx="0" ry="0" width="301" height="15" />
      <rect x="40" y="362" rx="0" ry="0" width="287" height="17" />
      <rect x="39" y="387" rx="0" ry="0" width="267" height="16" />
      <rect x="38" y="411" rx="0" ry="0" width="301" height="15" />
      <rect x="40" y="436" rx="0" ry="0" width="287" height="17" />
      <rect x="39" y="461" rx="0" ry="0" width="267" height="16" />
      <rect x="38" y="485" rx="0" ry="0" width="301" height="15" />
      <rect x="39" y="545" rx="6" ry="6" width="79" height="31" />
      <rect x="258" y="545" rx="0" ry="0" width="89" height="15" />
    </ContentLoader>
  );
}
